import HBIcon from "@/components/HBIcon";
import useAppStore from "@/context/store";
import imageUrl from "@/utils/imageUrl";
import classNames from "classnames";
import { findIndex } from "lodash";
import { useEffect, useMemo, useRef, useState } from "react";
import { When } from "react-if";
import styles from "./index.module.less";
const controlBtnWidth = 112;
export default function CollapseTab(props) {
  const { list, itemClick, displayRow = 3 } = props;
  const [isExpand, setIsExpand] = useState(false);
  const [maxLen, setMaxLen] = useState(0);
  const isInitRef = useRef(false);
  const { wrapperWidth } = useAppStore(({ wrapperWidth }) => ({
    wrapperWidth,
  }));

  useEffect(() => {
    let domArr = Array.from(
      document.querySelectorAll(`.${styles.transparentItem}`)
    );

    let firstDomTop = domArr?.[0]?.getBoundingClientRect()?.top;
    let rowHeight = getRowHeight(domArr?.[0]);
    domArr.every((item, index) => {
      let domTop = item.getBoundingClientRect().top;
      // 找到满足条件的元素
      if (domTop >= firstDomTop + rowHeight * displayRow) {
        // 找到换行前最后一个元素距离容器右边距离
        const distance = getDistanceToRightTarget(
          domArr[index - 1],
          item.parentNode
        );
        // 判断空间能否放下展开收起按钮
        setMaxLen(distance < controlBtnWidth ? index - 1 : index);
        return false;
      }
      setMaxLen(domArr.length);
      return true;
    });
  }, [displayRow, list, wrapperWidth]);

  useEffect(() => {
    if (!isInitRef?.current && maxLen) {
      // 初次进来时候，判断选中的tab是否被收起隐藏，如果被隐藏则展开
      isInitRef.current = true;
      let targetIndex = findIndex(list, (item: any) => item.active);
      if (targetIndex >= maxLen) {
        setIsExpand(true);
      }
    }
  }, [maxLen, list]);
  // 一行高度 = 元素高度+marginBottom
  const getRowHeight = (element) => {
    if (element) {
      let style = window.getComputedStyle(element);
      return parseFloat(style.height) + parseFloat(style.marginBottom);
    }
  };
  const showList = useMemo(() => {
    if (isExpand) {
      return list || [];
    } else {
      return list?.slice(0, maxLen) || [];
    }
  }, [isExpand, maxLen, list]);

  const showExpand = useMemo(() => {
    return maxLen && list?.length !== maxLen;
  }, [maxLen, list]);

  const getDistanceToRightTarget = (childEle, targetEle) => {
    const childRect = childEle.getBoundingClientRect();
    const targetRect = targetEle.getBoundingClientRect();

    // 计算子元素到目标元素右侧的距离
    return targetRect.right - childRect.right;
  };
  const change = () => {
    setIsExpand(!isExpand);
  };

  return (
    <>
      <div className={styles.list}>
        {showList?.map((item, index) => {
          return (
            <a
              key={index}
              className={classNames(styles.filterItem, {
                [styles.filterChoose]: item.active,
              })}
              {...item.props}
              onClick={(e) => {
                itemClick(item, e);
              }}
            >
              <div
                className={styles.bg}
                style={
                  item.img
                    ? {
                        backgroundImage: `url("${imageUrl(item.img, {
                          width: 86,
                        })}")`,
                      }
                    : {
                        backgroundColor: item.color || "#ffb7bd",
                      }
                }
              ></div>
              <div className={styles.text}>{item.name}</div>
            </a>
          );
        })}
        <When condition={showExpand}>
          <div
            className={classNames(styles.filterItem, styles.controlBtn)}
            onClick={change}
          >
            <div className={styles.bg}>
              <div className={styles.color}></div>
            </div>
            <div className={styles.text}>{isExpand ? "收起" : "更多"}</div>
            <HBIcon
              className={styles.icon}
              type={isExpand ? "ic_fold" : "ic_unfold"}
            />
          </div>
        </When>
      </div>
      {/* 用于计算的组件不展示 */}
      <div
        className={classNames([
          styles.list,
          styles.transparent,
          "calculateWrapper",
        ])}
      >
        {list?.map((item, index) => {
          return (
            <a
              href={item.props.href}
              key={index}
              className={classNames(styles.filterItem, styles.transparentItem)}
            >
              <div className={styles.text}>{item.name}</div>
            </a>
          );
        })}
      </div>
    </>
  );
}
